if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.sticky-atc__button');
        this.footer = document.querySelector('footer.footer') || document.querySelector('footer');
        this.pastRealButton = false;
        this.beforeFooter = true;

        // Real add-to-cart button: once it scrolls above the viewport, the
        // sticky bar is allowed to show.
        var realButton = document.querySelector(`#ProductSubmitButton-${this.dataset.formId.replace('product-form-', '')}`);
        if (realButton) {
          this.buttonObserver = new IntersectionObserver(
            (entries) => {
              // data-show-on-load (Retro Finder, 2026-10-16: paid mobile visitors never scroll to the in-page button):
              // the bar is visible from first paint and only steps aside while the real button is itself on screen.
              this.pastRealButton = this.dataset.showOnLoad === 'true'
                ? !entries[0].isIntersecting
                : !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
              this.update();
            },
            { threshold: 0 }
          );
          this.buttonObserver.observe(realButton);
        } else {
          this.pastRealButton = true;
        }

        // Footer: once it enters the viewport, hide the sticky bar so it
        // never sits on top of footer content.
        if (this.footer) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              this.beforeFooter = !entries[0].isIntersecting;
              this.update();
            },
            { threshold: 0, rootMargin: '0px 0px 0px 0px' }
          );
          this.footerObserver.observe(this.footer);
        }

        // Keep the sticky form's disabled/sold-out state in sync with the
        // real submit button when the variant selection changes.
        document.addEventListener('change', () => {
          requestAnimationFrame(() => this.syncButtonState(realButton));
        });

        // Aura 2026-10-14: the bar's price was rendered once for the first variant and never followed the
        // picker (showed $220 on a $195 variant). Follow Dawn's variant-change event, which fires after the
        // real button has been re-enabled, so the disabled state also stops sticking.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            this.showVariant(data && data.variant);
            this.syncButtonState(realButton);
          });
        }

        // Effectiveness event, separate from Shopify's own add_to_cart (which
        // still fires once via the normal product form submit).
        var pricesEl = this.querySelector('[data-sticky-atc-prices]');
        this.prices = pricesEl ? JSON.parse(pricesEl.textContent) : {};
        if (this.button) this.button.addEventListener('click', () => this.trackClick());

        this.update();
      }

      trackClick() {
        var form = document.getElementById(this.dataset.formId);
        var idInput = form && form.querySelector('[name="id"]');
        var variantId = idInput ? idInput.value : '';
        var params = {
          product_id: this.dataset.productId,
          variant_id: variantId,
          price: this.prices[variantId],
          currency: this.dataset.currency,
        };
        (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'sticky_atc_click' }, params));
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'sticky_atc_click', params);
        }
      }

      showVariant(variant) {
        var priceEl = this.querySelector('.sticky-atc__price');
        if (!priceEl || !variant) return;
        var amount = this.prices[String(variant.id)];
        if (amount === undefined) return;
        try {
          priceEl.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
          }).format(amount);
        } catch (e) {
          priceEl.textContent = '$' + Number(amount).toFixed(2);
        }
      }

      syncButtonState(realButton) {
        if (!realButton || !this.button) return;
        this.button.disabled = realButton.disabled;
        var label = realButton.querySelector('span');
        if (label) this.button.textContent = label.textContent.trim();
      }

      update() {
        var visible = this.pastRealButton && this.beforeFooter;
        this.classList.toggle('sticky-atc--visible', visible);
        document.documentElement.classList.toggle('has-sticky-atc', visible);
      }

      disconnectedCallback() {
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        if (typeof this.variantUnsubscribe === 'function') this.variantUnsubscribe();
        document.documentElement.classList.remove('has-sticky-atc');
      }
    }
  );
}
